<template>
    <div>
        <div v-if="isLoading" class="text-center my-10">
            <v-progress-circular
                indeterminate
                color="green accent-3"
                size="48"
            />
            <p class="mt-4 mb-0">
                Loading dependents...
            </p>
        </div>
        <!-- 1. Check if getUserDependent exists and is truthy -->
        <div v-else-if="getUserDependent">
            <!-- If STATUS exists and is not empty -->
            <div v-if="getUserDependent.STATUS != ''">
                <!-- Use this title if PRINCIPAL Logs in -->
                <v-card-title
                    v-if="getUserDependent.USER_DATA[0].MEMB_TYPE == $cookies.get('usermembn')"
                    class="nav"
                >
                    <h3>Member Dependents</h3>
                </v-card-title>

                <!-- Else use this title -->
                <v-card-title v-else>
                    <h3>Other Dependents</h3>
                </v-card-title>
                <v-divider />

                <div
                    v-for="(dependent, i) in getUserDependent.USER_DATA"
                    :key="i"
                    class="dependent-card-wrapper"
                >
                    <!-- DEPENDENTS CARD INFORMATIONS -->
                    <v-card
                        v-if="dependent.MEMB_N != $cookies.get('usermembn')"
                        class="my-10 mx-auto dependent-card elevation-5"
                        height="100%"
                    >
                        <!-- Dependents Informations -->
                        <v-container>
                            <!-- HMI DIGITAL ID of this dependent -->
                            <HmiCard
                                class="mb-8 mt-5"
                                :name="cardName(dependent)"
                                :company-name="dependent.COMP_NAME || ''"
                                :member-number="dependent.MEMB_N || ''"
                                :card-no="cardNo(dependent)"
                                :dob="dependent.F_BIRTHDATE || ''"
                                :sex="dependent.SEX || ''"
                                :dental="dependent.DENTAL || ''"
                                :status="statusMapper(dependent.MEMB_STATUS)"
                            />

                            <!-- ===== SUMMARY ===== -->
                            <div class="member-summary">
                                <v-avatar class="green accent-3 elevation-5" size="48">
                                    <v-icon large class="white--text">
                                        {{ mdiAccount }}
                                    </v-icon>
                                </v-avatar>
                                <div class="member-summary-text">
                                    <div class="member-summary-name">
                                        {{ dependent.NAME }}
                                    </div>
                                    <div class="member-summary-type">
                                        {{ memberType(dependent.MEMB_TYPE) }}
                                    </div>
                                </div>
                            </div>

                            <v-divider />
                            <MembershipInfo :detail-groups="detailGroups(dependent)" />
                            <MsuAccess
                                :hospital-code="dependent.HOSP_MSU || ''"
                                :hospital-desc="dependent.HOSP_MSU_DESC || ''"
                                :clinic-code="dependent.CLIN_MSU || ''"
                                :clinic-desc="dependent.CLIN_MSU_DESC || ''"
                                :status="statusMapper(dependent.MEMB_STATUS)"
                            />
                            <div
                                v-if="dependent.MEMB_TYPE == $cookies.get('usermembn')"
                                class="text-center mt-10"
                            >
                                <v-row align="center">
                                    <v-col cols="4" class="p-0">
                                        <v-btn
                                            small
                                            class="white accent-3 black--text"
                                            @click="
                                                (showDependentUtil = !showDependentUtil),
                                                (dependentSelection = i),
                                                displayUtil({ MEMBN: dependent.MEMB_N })
                                            "
                                        >
                                            View Utils
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-btn
                                            small
                                            class="white accent-3 black--text"
                                            @click="
                                                (showDependentEHB = !showDependentEHB),
                                                (dependentSelection = i),
                                                displayAREHB({ MEMBN: dependent.MEMB_N })
                                            "
                                        >
                                            View EHBs
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-btn
                                            small
                                            class="white accent-3 black--text"
                                            @click="
                                                (showDependentMBL = !showDependentMBL),
                                                (dependentSelection = i),
                                                displayMBL({ MEMBN: dependent.MEMB_N })
                                            "
                                        >
                                            View MBL
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>

                        <v-divider />

                        <!-- Dialogs -->
                        <InfoDependentUtil
                            :get-dependent-util="getUtil"
                            :dependent-selection="dependentSelection"
                            :card-count="i"
                            :show-dependent-util="showDependentUtil"
                            :dependent-name="dependent.NAME"
                            @showDialog="showDependentUtilDialogue"
                        />

                        <InfoDependentEHB
                            :get-dependent-e-h-b="getAREHB"
                            :dependent-selection="dependentSelection"
                            :card-count="i"
                            :show-dependent-e-h-b="showDependentEHB"
                            :dependent-name="dependent.NAME"
                            @showDialog="showDependentEHBDialogue"
                        />

                        <InfoDependentMBL
                            :get-dependent-m-b-l="getMBL"
                            :dependent-selection="dependentSelection"
                            :card-count="i"
                            :show-dependent-m-b-l="showDependentMBL"
                            :dependent-name="dependent.NAME"
                            @showDialog="showDependentMBLDialogue"
                        />
                    </v-card>
                </div>
            </div>

            <!-- 2. STATUS is empty -->
            <div v-else>
                <v-card-title class="nav">
                    <h3>No Dependents Found</h3>
                </v-card-title>
                <v-divider />
            </div>
        </div>

        <!-- 3. Catch-all when getUserDependent is false, null, or undefined -->
        <div v-else>
            <v-card-title class="nav">
                <h3>Unable to retrieve dependent data.</h3>
            </v-card-title>
            <v-divider />
        </div>
    </div>
</template>

<script>
import HmiCard from './../MembInfoComp/HmiCard.vue'
import MsuAccess from '../MembInfoComp/MsuAccess.vue'
import InfoDependentUtil from './InfoDependentUtil.vue'
import InfoDependentEHB from './InfoDependentEHB.vue'
import InfoDependentMBL from './InfoDependentMBL.vue'
import { moment } from '../../../utils/date-shim'

import { mapActions, mapGetters } from 'vuex'
import { mdiAccount } from '@mdi/js'
import MembershipInfo from '../MembInfoComp/MembershipInfo.vue'

const MANILA = '+0800'
const fmtDate = (d) => (d ? moment(d).utcOffset(MANILA).format('DD MMMM YYYY') : '')

export default {
    components: {
        HmiCard,
        InfoDependentUtil,
        InfoDependentEHB,
        InfoDependentMBL,
        MsuAccess,
        MembershipInfo
    },
    props: ['getUserDependent'],
    data: () => ({
        mdiAccount,
        isMobile: false,
        dependentSelection: '',
        footer_props: {
            'items-per-page-options': [5]
        },
        headers: [
            {
                text: 'Admission Date',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Release Date',
                align: 'center',
                sortable: false,
                class: 'teal--text'
            },
            {
                text: 'Availment Type',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Hospital/Clinic Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Doctor Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Hospital Bill Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Professional Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Retainer Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Diagnosis',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Procedure',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            }
        ],
        showDependentUtil: false,
        showDependentEHB: false,
        showDependentMBL: false
    }),
    computed: {
        ...mapGetters(['getUtil', 'NoUtil', 'getAREHB', 'getMBL']),
        // The details list under the card, rendered with v-for (no child components).
        isLoading() {
            return this.getUserDependent === null
        }
    },
    methods: {
        ...mapActions(['displayUtil', 'displayAREHB', 'displayMBL', 'getCsrfToken']),
        status(u) {
            return (u && u.MEMB_STATUS) || ''
        },
        msuAccess(u) {
            return {
                HOSP_MSU: u.HOSP_MSU || '',
                HOSP_MSU_DESC: u.HOSP_MSU_DESC || '',
                CLIN_MSU: u.CLIN_MSU || '',
                CLIN_MSU_DESC: u.CLIN_MSU_DESC || '',
                MEMB_STATUS: u.MEMB_STATUS || ''
            }
        },
        isActive(status) {
            return ['ACTIVE', 'WITH EXTENSION'].includes(status)
        },
        isExpired(u) {
            if (!u.EXPI_DATE) return false
            const exp = moment(u.EXPI_DATE).utcOffset(MANILA).startOf('day')
            const today = moment().utcOffset(MANILA).startOf('day')
            return exp.isBefore(today)
        },
        detailGroups(u) {
            return [
                {
                    title: 'Membership',
                    items: [
                        { label: 'Member Status', value: this.status(u), tone: this.isActive(this.status(u)) ? 'ok' : 'bad' },
                        { label: 'Member Type', value: this.memberType(u.MEMB_TYPE) },
                        { label: 'Room Type', value: u.ROOM_TYPE }
                    ]
                },
                {
                    title: 'Validity',
                    items: [
                        { label: 'Effectivity Date', value: fmtDate(u.EFF_DATE) },
                        { label: 'Expiration Date', value: fmtDate(u.EXPI_DATE), tone: this.isExpired(u) ? 'bad' : 'ok' }
                    ]
                }
            ]
        },
        memberType(membType) {
            return membType == null ? 'Principal' : 'Dependent'
        },
        statusMapper(status) {
            return ['ACTIVE', 'WITH EXTENSION'].includes(status)
        },
        // Name printed on the HMI card: "LAST, FIRST" + middle initial
        cardName(dependent) {
            return [dependent.NAME, dependent.MIDI_M].filter(Boolean).join(' ')
        },
        // NOTE: CARD_NO is a guess. Use the same logic as the principal's card
        // (MembInfo.vue) so both cards print the card number the same way.
        cardNo(dependent) {
            return dependent.CARD_NO || ''
        },

        showDependentUtilDialogue(showDependentUtil) {
            this.showDependentUtil = showDependentUtil
        },
        showDependentEHBDialogue(showDependentEHB) {
            this.showDependentEHB = showDependentEHB
        },
        showDependentMBLDialogue(showDependentMBL) {
            this.showDependentMBL = showDependentMBL
        }
    }
}
</script>

<style scoped>
@media (max-width: 599px) {
  .nav h3 {
    font-size: 24px;
    text-align: center;
    width: 100%;
  }

  .dependent-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .dependent-card {
    width: 85%;
  }
}
.msu-title {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #00796b;
}
/* ================= Summary row ================= */
.member-summary {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 28px 16px;
}
.member-summary-text {
  flex: 1 1 auto;
  min-width: 0;
}
.member-summary-name {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
}
.member-summary-type {
  font-size: 13px;
  color: rgba(0, 0, 0, .6);
}
.member-summary-status {
  flex: 0 0 auto;
  font-weight: 700;
}
</style>
